import { render, staticRenderFns } from "./ChannelTopBar.vue?vue&type=template&id=6ab65a52&scoped=true"
import script from "./ChannelTopBar.vue?vue&type=script&lang=js"
export * from "./ChannelTopBar.vue?vue&type=script&lang=js"
import style0 from "./ChannelTopBar.vue?vue&type=style&index=0&id=6ab65a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab65a52",
  null
  
)

export default component.exports